import { render, staticRenderFns } from "./list-services.vue?vue&type=template&id=a70260bc&"
import script from "./list-services.vue?vue&type=script&lang=js&"
export * from "./list-services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports